import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const infoCircle: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M8-1.25V-2.5a.22.22 0 0 0-.078-.172.22.22 0 0 0-.172-.078H7v-4a.22.22 0 0 0-.078-.172A.22.22 0 0 0 6.75-7h-2.5a.26.26 0 0 0-.187.078A.23.23 0 0 0 4-6.75v1.25q0 .111.063.188.075.063.187.062H5v2.5h-.75a.26.26 0 0 0-.187.078A.23.23 0 0 0 4-2.5v1.25q0 .111.063.188Q4.138-1 4.25-1h3.5q.106 0 .172-.062A.26.26 0 0 0 8-1.25m-1-7V-9.5a.22.22 0 0 0-.078-.172.22.22 0 0 0-.172-.078h-1.5a.26.26 0 0 0-.187.078A.23.23 0 0 0 5-9.5v1.25q0 .111.063.188Q5.138-8 5.25-8h1.5q.106 0 .172-.062A.26.26 0 0 0 7-8.25m4.188.234Q11.998-6.64 12-5q-.002 1.628-.812 3.016A5.9 5.9 0 0 1 9.016.188 5.85 5.85 0 0 1 6 1 5.9 5.9 0 0 1 2.984.188 5.95 5.95 0 0 1 .797-1.984 5.95 5.95 0 0 1 0-5a5.91 5.91 0 0 1 2.984-5.187A5.9 5.9 0 0 1 6-11q1.64.001 3.016.813a5.9 5.9 0 0 1 2.172 2.171m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "12",
    width: "12",
  }
};
